import { RolesPermissionsFileRepository } from "../repositories/roles-permissions-file-repository";
import { RolesPermissionsRepositoryInterface } from "../repositories/roles-permissions-repository-interface";

export class RolesPermissionsService {
  private rolesPermissionsRepository: RolesPermissionsRepositoryInterface;

  constructor(
    rolesPermissionsRepository: RolesPermissionsRepositoryInterface = new RolesPermissionsFileRepository(),
  ) {
    this.rolesPermissionsRepository = rolesPermissionsRepository;
  }

  public getRolesPermissionsRepository(): RolesPermissionsRepositoryInterface {
    return this.rolesPermissionsRepository;
  }

  public setRolesPermissionsRepository(
    rolesPermissionsRepository: RolesPermissionsRepositoryInterface,
  ) {
    this.rolesPermissionsRepository = rolesPermissionsRepository;
  }

  public getPermissionsForRoles(roles: string[]): Set<string> {
    return this.rolesPermissionsRepository.getPermissionsForRoles(roles);
  }
}
